import { ReactNode } from "react";
import { Tooltip } from "antd";
import CurrencyAmount from "src/components/CurrencyAmount";

const CODE_CLASS =
  "font-mono tabular-nums tracking-tight leading-tight inline-block max-w-full break-all text-3xl sm:text-4xl font-bold";
const GRADIENT_CODE_CLASS = `${CODE_CLASS} bg-gradient-to-r from-blue-900 to-blue-600 dark:from-blue-300 dark:to-blue-200 bg-clip-text text-transparent`;

type WalletBalanceDisplayProps = {
  primaryAmount: ReactNode;
  primaryUnit: string;
  heroColor?: string;
  rateLabel?: ReactNode;
  rateAmount?: number | string;
  rateCurrency?: "IRT" | "GBP" | "USDT";
  children?: ReactNode;
};

export function WalletBalanceDisplay({
  primaryAmount,
  primaryUnit,
  heroColor,
  rateLabel,
  rateAmount,
  rateCurrency = "IRT",
  children,
}: WalletBalanceDisplayProps) {
  const hasRate = Boolean(rateLabel && rateCurrency);

  const amountRow = (
    <div className="flex flex-wrap items-baseline gap-x-2 min-w-0 max-w-full">
      <code
        className={heroColor ? CODE_CLASS : GRADIENT_CODE_CLASS}
        style={{ direction: "ltr", unicodeBidi: "isolate", color: heroColor }}
      >
        {primaryAmount}
      </code>
      <span className="font-bold shrink-0">{primaryUnit}</span>
    </div>
  );

  return (
    <>
      {hasRate ? (
        <Tooltip
          title={
            <span className="inline-flex items-baseline">
              {rateLabel}
              <CurrencyAmount
                className="mx-1"
                fontSize={12}
                amount={rateAmount}
                currency={rateCurrency}
              />
            </span>
          }
        >
          <span className="inline-block cursor-help">{amountRow}</span>
        </Tooltip>
      ) : (
        amountRow
      )}
      {children}
    </>
  );
}
